// Chakra and React imports
import {
  useEffect,
  useState,
} from "react";
import {
  Box,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Icon,
  HStack,
  Text
} from "@chakra-ui/react";

// Components
import Card from "components/card/Card";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import FsButton from "./components/FullscreenButton";
import { DashboardPannel } from "./components/DashboardPannel";

// Icons
import { MdClose } from "react-icons/md";

import { useNavigate } from "react-router-dom";

import Dashboards from "../dashboardElements";
import { Dashboard } from "api/types";
import { LuAlignVerticalSpaceAround } from "react-icons/lu";

function load(key: string) {
  let i = sessionStorage.getItem(key)
  return i !== null ? JSON.parse(i) : []
}

export default function DashboardTabManager() {

  const [key, setKey] = useState(Math.random())
  const [loadedDashboards, setLoadedDashboards] = useState(load('dashboards'))
  const fsHandler = useFullScreenHandle()
  const navigate = useNavigate()

  function updateDashboards(op: string, value: Dashboard) {

    let newLoaded: any[] = loadedDashboards
    let valueExists = newLoaded.filter((d) => d.id === value.id).length > 0
    if (op === '+' && !valueExists) {
      newLoaded.push(value)
    } else if (op === '-' && valueExists) {
      newLoaded = newLoaded.filter((d) => d.id !== value.id)
    }

    setLoadedDashboards(newLoaded)
    setKey(Math.random())
  }

  const dashboardTabs = loadedDashboards.map((ds: Dashboard) => (
    <Tab key={ds.id}>
      <HStack>
        <Text>{ds.name}</Text>
        <Icon as={MdClose} _hover={{ color: 'red.300' }} onClick={() => updateDashboards('-', ds)} />
      </HStack>
    </Tab>
  ))
  const dashboardPannels = loadedDashboards.map((ds: Dashboard) => (
    <TabPanel key={ds.id}>
      <DashboardPannel dashboard={ds} isFullscreen={fsHandler.active} />
    </TabPanel>
  ))

  useEffect(() => { if (loadedDashboards.length === 0 || !loadedDashboards) { navigate('/dashboards/elements') } })

  const dashboardCount = Number(sessionStorage.getItem('dashboard-count'))
  const dashboardXLHeigth = dashboardCount >= 8 ? "100%": "calc(100vh - 225px)"
  const dashboard2XLHeigth = dashboardCount >= 8 ? "100%": "calc(100vh -230px)"

  return (
    <Box pt={{ base: "100px", md: "65px"}}>
      <Box textAlign="center" height="calc(100vh - 300px)" alignContent="center" display={{ base: "flex", md: "none" }} justifyContent='center'>
        <Box alignSelf={'center'}>
          <Text >
            Voltee su dispositivo para usar esta funcion.
          </Text>
          <Icon as={LuAlignVerticalSpaceAround} mt="20px" w="100px" h="100px" />
        </Box>
      </Box>
      <FullScreen handle={fsHandler}>
        <Card h='100%' w='100%' px={{ md: "10px" }} mb="20px" display={{ base: 'none', md: 'block' }} pb={{ md: "5px" }}>

          <Tabs size='sm' variant='enclosed' key={key} defaultIndex={dashboardTabs.length - 1} >
            <TabList position='relative' zIndex={3} backgroundColor='#111c44'>
              {dashboardTabs}
              <Tab>+</Tab>
              <FsButton handler={fsHandler} />
            </TabList>
            <TabPanels>
              {dashboardPannels}
              <TabPanel>
                <Dashboards
                  containerH={fsHandler.active ? "90vh" : { base: '100%', xl: dashboardXLHeigth, '2xl': dashboard2XLHeigth }}
                  containerMt={{ md: '10px', lg: '0px' }}
                  containerMb={{base: "0px", xl: "10px"}}
                  containerP="20px"
                  setFN={updateDashboards} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Card>
      </FullScreen>
    </Box>
  );
}
